<div class="w-100 h-100">
    <div class="row" style="padding-top: 40px; padding-bottom: 25px;">
        <div class="col-md-12">
            <div class="form-row justify-content-between align-items-baseline">
                <div class="col-auto">
                    <label class="header_text mb-3">
                        {{$t('shared.suggestionsAndSystemEnhancement')}}
                    </label>
                </div>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-md-12">
            <div class="card card_layout">
                <div class="card-body">
                    <div class="row">
                        <div class="col-md-4">
                            <div class="input-group mb-3">
                                <input class="form-control border-right-0 border-left" type="text" @input="search"
                                    v-model="filterModel.providerName" :placeholder="$t('shared.providerName')" />
                                <div class="input-group-append">
                                    <span class="input-group-text right gray">
                                        <i class="fas fa-search"></i>
                                    </span>
                                </div>
                            </div>
                        </div>

                        <div class="col-md-4">
                            <v-select style="width: 100%;" v-model="filterModel.service" :items="services"
                                item-text="name" item-value="id" :placeholder="$t('shared.serviceName')" solo dense
                                clearable @change="search" attach></v-select>
                        </div>
                    </div>

                    <template>
                        <v-data-table :headers="headers" :items="suggestions" :total-items="suggestionsCount"
                            :rows-per-page-text="$t('shared.rowsPerPage')" :rows-per-page-items='[10, 25, 50, 100]'
                            @update:pagination="updatePaginate" class="elevation-1 table-striped">
                            <template v-slot:items="props">
                                <tr>
                                    <td class="text-center">{{ props.item.providerName }}</td>
                                    <td class="text-center">{{ getServiceName(props.item.service) }}</td>
                                    <td class="text-center">{{ props.item.title }}</td>
                                    <td class="text-center">{{ props.item.createdDate }}</td>
                                    <td class="text-center">
                                        <div class="d-flex">
                                            <router-link :to="'/SuggestionsDetails/' + props.item.id" tag="a" class="mx-1">
                                                <i class="fas fa-info-circle Icon_Info"></i>
                                            </router-link>
                                        </div>
                                    </td>
                                </tr>
                            </template>
                        </v-data-table>
                    </template>
                </div>
            </div>
        </div>
    </div>
</div>